import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebaseconfig'; // Import your auth config
import { signOut } from 'firebase/auth'; // Import signout method
import { 
  LayoutDashboard, 
  UserPlus, 
  MapPin, 
  PlusSquare, 
  LogOut, 
  Zap 
} from 'lucide-react';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Helper to highlight the active link
  // FIXED: Updated these paths to match your actual App.js routes
  const isActive = (path) => location.pathname === path ? 'bg-success text-white shadow-sm' : 'text-dark hover-bg-light';

  const handleLogout = async () => {
    if (window.confirm("Are you sure you want to exit the Admin Panel?")) {
      try {
        await signOut(auth); // This clears the Firebase session
        navigate('/admin-login'); // Sends you back to login
      } catch (error) {
        console.error("Error logging out:", error);
      }
    }
  };

  return (
    <div className="d-flex flex-column vh-100 p-3 bg-white border-end shadow-sm" style={{ width: '280px', position: 'fixed', left: 0, top: 0 }}>
      {/* Logo Section */}
      <div className="d-flex align-items-center mb-5 ps-2">
        <Zap className="text-success me-2" fill="currentColor" size={28} />
        <span className="fs-4 fw-bold text-dark tracking-tight">Denial Admin</span>
      </div>

      {/* Navigation Links */}
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item mb-2">
          <Link to="/admin-panel" className={`nav-link d-flex align-items-center gap-3 py-3 rounded-3 transition-all ${isActive('/admin-panel')}`}>
            <LayoutDashboard size={20} />
            <span className="fw-medium">Dashboard</span>
          </Link>
        </li>
        <li className="nav-item mb-2">
          <Link to="/admin-panel-addproject" className={`nav-link d-flex align-items-center gap-3 py-3 rounded-3 transition-all ${isActive('/admin-panel-addproject')}`}>
            <PlusSquare size={20} />
            <span className="fw-medium">Add Project</span>
          </Link>
        </li>
        <li className="nav-item mb-2">
          <Link to="/admin-panel-client" className={`nav-link d-flex align-items-center gap-3 py-3 rounded-3 transition-all ${isActive('/admin-panel-client')}`}>
            <UserPlus size={20} />
            <span className="fw-medium">Manage Clients</span>
          </Link>
        </li>
        <li className="nav-item mb-2">
          <Link to="/admin-panel-state" className={`nav-link d-flex align-items-center gap-3 py-3 rounded-3 transition-all ${isActive('/admin-panel-state')}`}>
            <MapPin size={20} />
            <span className="fw-medium">Manage States</span>
          </Link>
        </li>
      </ul>

      <hr className="text-muted" />

      {/* Bottom Section */}
      <div className="mt-auto">
        <button 
          onClick={handleLogout} 
          className="nav-link d-flex align-items-center gap-3 py-3 text-danger fw-bold border-0 bg-transparent w-100 text-start rounded-3 hover-danger"
        >
          <LogOut size={20} />
          <span>Exit Admin</span>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;